import { BybButton } from "@Components/common/byb-ds";
import PositionSelectorDialog from "@Components/game/common/position-selector/position-selector-dialog";
import { useCareerContext } from "@Context/game/career/career-context";
import { AnalyticsEvents } from "@Enums/index";
import { useSelectionDisplayText } from "@hooks/game/selection/use-selection-display-text";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import useI18n from "@i18n";
import { ChevronRight } from "@mui/icons-material";
import { Typography, useTheme } from "@mui/material";
import { AllPositionsButton, CareerActionsContainer } from "./styled-components";
import Button from "@Components/generic/button";

const CareerActionButtons = () => {
  const { i18n } = useI18n();
  const { getPositionSelectionDisplayText } = useSelectionDisplayText();
  const theme = useTheme();
  const { onPlayClicked, starting, openPositionDialog, selectedPositions, isPositionDialogOpen, closePositionDialog, handlePositionsSelected } =
    useCareerContext();

  const { track } = useAnalytics();

  return (
    <>
      <CareerActionsContainer>
        <AllPositionsButton onClick={openPositionDialog}>
          <Typography variant="text1xl600" color="dsBase.v200">
            {getPositionSelectionDisplayText(selectedPositions)}
          </Typography>
          <ChevronRight sx={{ color: theme.palette.dsNeutral.v200 }} fontSize="large" />
        </AllPositionsButton>

        <Button
          size="large"
          fontVariant="text1xl600"
          onClick={() => {
            track(AnalyticsEvents.career_started, {
              positions: selectedPositions,
            });
            onPlayClicked();
          }}
          disabled={starting}
          sx={{ flex: 1 }}
        >
          {i18n("play")}
        </Button>
      </CareerActionsContainer>

      <PositionSelectorDialog
        isOpen={isPositionDialogOpen}
        onClose={closePositionDialog}
        onPositionsSelected={handlePositionsSelected}
        initialPositions={selectedPositions}
      />
    </>
  );
};

export default CareerActionButtons;
